import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  payoutBlockInfoGet,
  usePayoutBlockInfo,
} from "../../../redux/slices/payoutBlockInfoSlice";
import { Button, Card, CardBody, CardHeader, Form } from "reactstrap";
import { Table, TableRow } from "../../../components/Table";
import { responseToaster } from "../../../helperFunctions";
import { useForm } from "react-hook-form";
import { FILTER } from "../../../constant";
import ControlledInput from "../../../components/Custom/Forms/Controller/ControlledInput";
import { useRole } from "../../../redux/slices/authSlice";
import PayoutBlockInfoModal from "../../../components/Custom/Modals/PayoutBlockInfo/PayoutBlockInfoModal";
import { FaRegEye } from "react-icons/fa";
import PayoutBlockInfoShowModal from "./PayoutBlockInfoShowModal";
import PayoutBlockInfoShowContent from "./PayoutBlockInfoShowContent";

const PayoutBlockInfo = () => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShowModalOpen, setIsShowModalOpen] = useState(false);
  const [showInlineModalData, setShowInlineModalData] = useState(null);

  const cutomerManagement = usePayoutBlockInfo();
  const cutomerManagementItems = Object.entries?.(cutomerManagement?.data || {})?.map?.(
    ([k, v]) => {
      const { merchant_details, ...rest } = v;
      return {
        merchantId: k,
        merchantName: v?.merchant_details?.admin_merchant_name,
        values: rest,
      };
    }
  );
  const initialValues = {
    blockData: "",
  };

  const [filter, setFilter] = useState({ ...FILTER, isToast: false });
  const [filterColumns, setFilterColumns] = useState([]);
  const role = useRole("Payout Block Info");

  const columns = [
    {
      title: "Merchant ID",
      name: "merchantId",
    },
    {
      title: "Merchant Name",
      name: "merchantName",
    },
    {
      title: "ACTION",
      name: "action",
      Cell: (data) => {
        return (
          <>
            <div className="d-flex flex-row gap-50">
              {role?.includes("payoutBlockInfo-list") ? (
                <Button
                  color="primary"
                  className="btn-smallsize"
                  onClick={() => setIsShowModalOpen(data)}
                  title="Show Info"
                >
                  <FaRegEye />
                </Button>
              ) : null}
            </div>
          </>
        );
      },
    },

  ];

  const onGet = async () => {
    setIsLoading(true);
    try {
      const {
        isFilter,
        isToast,
        page_no,
        limit,
        ...rest
      } = filter;
      const payload = isFilter
        ? {
          filter_data: {
            ...rest,
          },
          page_no,
          limit,
        }
        : {
          page_no,
          limit,
        };
      const res = await dispatch(payoutBlockInfoGet(payload)).unwrap();
      if (isFilter) {
        setShowInlineModalData(
          Object.entries?.(res?.data || {})?.map?.(([key, data]) => {
            const { merchant_details, ...rest } = data;

            return {
              merchantId: merchant_details?.merchant_id || key,
              merchantName: merchant_details?.admin_merchant_name,
              values: rest,
            };
          })
        );
      }
      if (isToast) {
        responseToaster(res);
      }
      setIsLoading(false);
    } catch (err) {
      if (filter?.isFilter) {
        setShowInlineModalData([]);
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const newColumns = columns?.map((item) => item?.name);
    setFilterColumns(newColumns);
  }, []);

  useEffect(() => {
    if (role.includes("payoutBlockInfo-list")) {
      onGet();
    }
  }, [filter]);

  const onSubmit = async () => {
    const values = getValues();
    setFilter({
      ...filter,
      ...values,
      ...FILTER,
      isFilter: true,
      isToast: true,
    });
  };

  const { control, handleSubmit, getValues, reset } = useForm({
    defaultValues: initialValues,
  });

  return (
    <>
      {role.includes("payoutBlockInfo-list") ? (
        <>
          <div className="support-log-main-div">
            <Card>
              <CardHeader className="flex-column  align-items-start">
                <div className="d-flex align-items-center w-100 justify-content-between">
                  <h4 className="main-title">
                    <b>Payout Block Info</b>
                  </h4>
                  {role?.includes("payoutBlockInfo-add") ? (
                    <Button
                      color="primary"
                      title="Bank Statement"
                      onClick={() => setIsModalOpen(true)}
                    >
                      Add Payout Block Info
                    </Button>
                  ) : null}
                </div>
              </CardHeader>
              <CardBody>
                <Form
                  className="d-flex my-xl-auto right-content align-items-end button-space"
                  style={{ flexWrap: "wrap" }}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <ControlledInput
                    placeholder="Enter Search Value"
                    name="blockData"
                    label="Search"
                    control={control}
                  />
                  <Button type="submit" color="primary">
                    Apply
                  </Button>
                  <Button
                    type="button"
                    color="danger"
                    onClick={() => {
                      reset();
                      setFilter({ ...FILTER, isFilter: false, isToast: false });
                    }}
                  >
                    Clear
                  </Button>
                </Form>
              </CardBody>
            </Card>
            <Card>
              {filter?.isFilter ? (
                <PayoutBlockInfoShowContent
                  data={showInlineModalData}
                  loading={isLoading}
                  onGet={() => onGet()}
                  onClose={() => {
                    setShowInlineModalData(false);
                  }}
                />
              ) : (
                <Table
                  columns={columns}
                  isLoading={isLoading}
                  data={cutomerManagementItems || []}
                  isData={!!cutomerManagementItems?.length}
                  filterColumns={filterColumns}
                  count={cutomerManagementItems?.total_item || 0}
                  pagination={filter}
                  isExpandable={false}
                  handlePaginationChange={(pagination) => {
                    setFilter({
                      ...filter,
                      ...pagination,
                      isToast: false,
                    });
                  }}
                >
                  {cutomerManagementItems?.map?.((item) => {
                    return (
                      <TableRow
                        columns={columns}
                        item={item}
                        filterColumns={filterColumns}
                        isExpandable={false}
                      />
                    );
                  })}
                </Table>)}
            </Card>
          </div>
        </>
      ) : null}
      <PayoutBlockInfoModal
        isModalOpen={isModalOpen}
        onGet={() => onGet()}
        onCloseModal={() => {
          setIsModalOpen(false);
        }}
      />
      <PayoutBlockInfoShowModal
        data={isShowModalOpen}
        onGet={() => onGet()}
        onClose={() => {
          setIsShowModalOpen(false);
        }}
      />
    </>
  );
};

export default PayoutBlockInfo;
